import { render, staticRenderFns } from "./manage-user-groups.vue?vue&type=template&id=4cbb51b4&scoped=true&"
import script from "./manage-user-groups.vue?vue&type=script&lang=js&"
export * from "./manage-user-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb51b4",
  null
  
)

export default component.exports